<template>
  <footer id="footer" class="footer solid-bg">
			<!-- !Bottom-bar -->
			<div id="bottom-bar" class="logo-left" role="contentinfo">
				<div class="wf-wrap">
					<div class="wf-container-bottom">

						<div id="branding-bottom"><img
									class="preload-me"
									src="../assets/3dwich_web.png"
									srcset="../assets/3dwich_web.png 62w" width="180"
									height="13" sizes="180px" alt="三文建筑设计" /></div>
						<div class="wf-float-right">
							<div class="bottom-text-block">
								<p style="text-align:center;line-height: 20px;">© 3andwich Design 2022. All rights reserved.京ICP备16048899号-1</p>
							</div>
						</div>

					</div><!-- .wf-container-bottom -->
				</div><!-- .wf-wrap -->
			</div><!-- #bottom-bar -->
		</footer><!-- #footer -->
</template>


<script>
import Axios from "axios";
export default {
  data() {
    return {
      src: "",
      address:'',
      qqNum:'',
      phoneOne:'',
      email:'',
      beian:'',
      menu_product: [],
      menu_solution: [],
    };
  },
  methods: {
  },
};
</script>


<style lang="scss" scoped>
@media (min-width: 1200px) {
	#footer.solid-bg {
	background: #2e2b36 none repeat center top;
	margin-top: -20px;
	
}

#footer>.wf-wrap,
#footer #bottom-bar>.wf-wrap {
	padding: 0 20% 0 20%;
}

#bottom-bar {
	font-size: 11px;
	line-height: 20px;
	color: #615f69;
	position: relative;
	z-index: 9;
	margin: 0 auto;
}

#footer>.wf-wrap {
	width: 1300px;
}

#bottom-bar {
	font-size: 11px;
	line-height: 20px;
	color: #615f69;
	position: relative;
	z-index: 9;
	margin: 0 auto;
}

#bottom-bar .wf-container-bottom {
	display: -ms-flexbox;
	display: -ms-flex;
	display: flex;
	-ms-align-items: center;
	-ms-flex-align: center;
	align-items: center;
	-ms-flex-pack: space-between;
	-ms-justify-content: space-between;
	justify-content: space-between;
	box-sizing: border-box;
}

.wf-container-bottom {
	padding: 10px 0 10px 0;
	min-height: 40px;
}

}

// @media (min-width: 1200px) {
//   @import "../style/base.scss";
//   @import "../style/footer.scss";
// }
@media (max-width: 1199px) {
//   @import "../style/mb.scss";
//   @import "../style/m-footer.scss";
  #footer.solid-bg {
	background: #2e2b36 none repeat center top;
	margin-top: -20px;
}

#footer>.wf-wrap,
#footer #bottom-bar>.wf-wrap {
	padding: 0 0px 0 0px;
}

#bottom-bar {
	font-size: 11px;
	line-height: 20px;
	color: #615f69;
	position: relative;
	z-index: 9;
	margin: 0 auto;
}

#footer>.wf-wrap {
	width: 1300px;
}

#bottom-bar {
	font-size: 10px;
	line-height: 20px;
	color: #615f69;
	position: relative;
	z-index: 9;
	margin: 0 auto;
}
#branding-bottom{
	text-align: center !important;
}
.wf-float-right{
	width: 100vw !important;
	overflow: hidden !important;
}
#bottom-bar .wf-container-bottom {
	box-sizing: border-box;
}
.bottom-text-block{
	p{
		margin:0 auto;
		font-size:10px;
		width:80%;
		text-align: center;
	}
	
}
.wf-container-bottom {
	padding: 10px 0 10px 0;
	min-height: 40px;
}

}
</style>